import React from 'react';
import './Screen.css';
import RichText from './RichText';

function HistoryDisplay({ history = [], variables = {}, viewingPhraseIndex = null, onPhraseSelect }) {
  if (!history || history.length === 0) {
    return null;
  }

  // Определяем текущий индекс фразы для фильтрации
  const currentPhraseIndex = viewingPhraseIndex !== null && viewingPhraseIndex !== undefined 
    ? viewingPhraseIndex 
    : (variables.viewingPhraseIndex !== undefined ? variables.viewingPhraseIndex : variables.currentPhraseIndex || 0);

  // Фильтруем историю по текущей фразе
  const filteredHistory = history.filter(item => {
    if (item.phraseIndex === null || item.phraseIndex === undefined) {
      // Если phraseIndex не указан, считаем что это первая фраза (индекс 0)
      return currentPhraseIndex === 0;
    }
    return item.phraseIndex === currentPhraseIndex;
  });

  // Определяем количество уникальных фраз в истории
  const phraseIndices = [...new Set(history.map(item => item.phraseIndex !== null && item.phraseIndex !== undefined ? item.phraseIndex : 0))].sort((a, b) => a - b);

  return (
    <div className="history-container">
      {/* Кнопки переключения между фразами */}
      {phraseIndices.length > 1 && (
        <div className="history-phrase-switcher">
          {phraseIndices.map(index => (
            <button
              key={index}
              className={`history-phrase-button ${currentPhraseIndex === index ? 'active' : ''}`}
              onClick={() => onPhraseSelect && onPhraseSelect(index)}
            >
              Фраза {index + 1}
            </button>
          ))}
        </div>
      )}

      {/* История текущей фразы */}
      {filteredHistory.map((item, index) => {
        // Текст истории рендерится через RichText (подстановка переменных + *акценты*).
        // Для user сообщений показываем только value (ответ пользователя),
        // text уже был показан в предыдущем system сообщении.
        if (item.type === 'user') {
          return (
            <div key={index} className="screen-history">
              {item.value && (
                <p className="history-input-value">
                  <RichText text={item.value} variables={variables} />
                </p>
              )}
            </div>
          );
        }
        // Для system сообщений показываем только text (вопрос/информация)
        return (
          <div key={index} className="screen-history">
            <p className="history-text">
              <RichText text={item.text} variables={variables} />
            </p>
          </div>
        );
      })}
    </div>
  );
}

export default HistoryDisplay;

